/* reads config from data-* on the mount nodes so the theme's custom_liquid stays lean.
 * also injects the audiobook-sample strip (no inline markup in the theme). */
(function(){
  function A(el,n){ return el.getAttribute(n); }
  var AUDIO_URL = "https://cdn.shopify.com/s/files/1/0282/1934/2926/files/Origins.mp3?v=1783625972";

  function fmt(t){ if(!isFinite(t)||t<0) t=0; var m=Math.floor(t/60), s=Math.floor(t%60); return m+":"+(s<10?"0":"")+s; }


  function audio(col){
    if(!col || col.querySelector('.sb3d-audio')) return;
    var PLAY='<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';
    var PAUSE='<svg viewBox="0 0 24 24"><path d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg>';
    var w=document.createElement('div'); w.className='sb3d-audio';
    w.innerHTML='<button class="sb3d-audio-btn" type="button" aria-label="Play Origins audio sample">'+PLAY+'</button>'
      +'<div class="sb3d-audio-main"><div class="sb3d-audio-label">Sample &middot; 6:24</div>'
      +'<div class="sb3d-audio-sub">First 5 minutes, free</div>'
      +'<div class="sb3d-audio-track"><div class="sb3d-audio-fill"></div></div>'
      +'<div class="sb3d-audio-time">0:00 / 6:24</div></div>';
    col.appendChild(w);
    var btn=w.querySelector('.sb3d-audio-btn'), fill=w.querySelector('.sb3d-audio-fill'),
        track=w.querySelector('.sb3d-audio-track'), time=w.querySelector('.sb3d-audio-time'), el=null;
    function ensure(){ // lazy: no audio bytes until the visitor hits play
      if(el) return el;
      el=new Audio(); el.preload='none'; el.src=AUDIO_URL;
      el.addEventListener('timeupdate',function(){ var d=el.duration||0; fill.style.width=(d?(el.currentTime/d*100):0)+'%'; time.textContent=fmt(el.currentTime)+' / '+fmt(d); });
      el.addEventListener('loadedmetadata',function(){ time.textContent='0:00 / '+fmt(el.duration); });
      el.addEventListener('ended',function(){ btn.innerHTML=PLAY; el.currentTime=0; });
      return el;
    }
    btn.addEventListener('click',function(){ var a=ensure(); if(a.paused){ a.play(); btn.innerHTML=PAUSE; } else { a.pause(); btn.innerHTML=PLAY; } });
    track.addEventListener('click',function(e){ var a=ensure(); var r=track.getBoundingClientRect(); var p=(e.clientX-r.left)/r.width; if(a.duration){ a.currentTime=Math.max(0,Math.min(1,p))*a.duration; } });
  }

  var DESC = {
    stack: "The easiest stack to start with. Our clean daily fuel is our greens and reds formula, and our most popular starter.",
    bundle: "Everything in the Daily Stack for daily fuel and immune support, plus the PR Package, an exclusive gear drop with a lifting belt, straps, and a limited-edition Keep apparel piece."
  };
  function accordions(){
    Object.keys(DESC).forEach(function(val){
      var input=document.querySelector('.sa-plan input[value="'+val+'"]');
      if(!input) return;
      var label=input.closest ? input.closest('.sa-plan') : input.parentNode;
      if(!label || label.querySelector('.sb3d-learn')) return;
      var btn=document.createElement('button'); btn.type='button'; btn.className='sb3d-learn';
      btn.setAttribute('aria-label','Show details for this add-on'); btn.setAttribute('aria-expanded','false');
      btn.innerHTML='Details <span class="sb3d-chev" aria-hidden="true">&#9662;</span>';   // rotates when open
      var panel=document.createElement('div'); panel.className='sb3d-desc'; panel.textContent=DESC[val];  // collapsed via CSS max-height
      var main=label.querySelector('.sa-plan-main') || label;
      main.appendChild(btn);   // sits under the row's sub-text (visible, no right-edge overflow)
      if(label.parentNode) label.parentNode.insertBefore(panel, label.nextSibling);
      btn.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation();
        var open=panel.classList.toggle('sb3d-open'); btn.classList.toggle('sb3d-openbtn',open);
        btn.setAttribute('aria-expanded', open?'true':'false');   // inline expand, no navigation/modal
      });
    });
  }

  function revealOffer(){  // visual scroll-reveal only; card always in DOM, button always clickable
    var card=document.querySelector('.sa-card');
    if(!card || !('IntersectionObserver' in window)) return;   // no IO: leave fully visible
    card.classList.add('sb3d-reveal');
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ card.classList.add('sb3d-revealed'); io.disconnect(); } }); }, {rootMargin:'0px 0px -8% 0px'});
    io.observe(card);
  }

  function boot(){
    var b=document.getElementById('sb3d-book');
    if(b && window.ScarsBook){ ScarsBook.lazy(b, {front:A(b,'data-front'),back:A(b,'data-back'),spine:A(b,'data-spine')}, A(b,'data-three')); }
    audio(document.querySelector('.sb3d-wrap'));  // audio sample, below book+story (grid-area)
    accordions();
    revealOffer();
  }
  function ready(){ if(window.ScarsBook){ boot(); } else { var i=setInterval(function(){ if(window.ScarsBook){ clearInterval(i); boot(); } },40); } }
  if(document.readyState!=='loading'){ ready(); } else { document.addEventListener('DOMContentLoaded', ready); }
})();
